<template>
    <div class="network-error">
        <van-row type="flex" justify="center" align="center" :style="{ height: contentHeight + 'px'}">
            <van-col style="height:230px">
                <van-row class="network-error-icon" type="flex" justify="center" align="center">
                    <van-col>
                        <van-icon name="fail" />
                    </van-col>
                </van-row>

                <van-row class="network-error-tip" type="flex" justify="center" align="center">
                    <van-col>
                        <span>{{text}}</span>
                    </van-col>
                </van-row>

                <van-row v-if="retry" class="network-error-button" type="flex" justify="center" align="center">
                    <van-col>
                        <van-button size="small" @click="onClick">重试</van-button>
                    </van-col>
                </van-row>
            </van-col>
        </van-row>
    </div>
</template>

<script>
export default {
  computed: {
    contentHeight() {
      return document.documentElement.clientHeight;
    },
    text() {
      if (this.$route.query.text) {
        return this.$route.query.text;
      } else {
        return "操作失败，请稍后重试。";
      }
    },
    retry() {
      if (this.$route.query.retry != undefined) {
        return this.$route.query.retry;
      } else {
        return true;
      }
    }
  },
  methods: {
    onClick() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
.network-error {
  background-color: white;

  &-icon {
    text-align: center;
    color: #38f;
    font-size: 50px;
  }

  &-tip {
    height: 50px;
    font-size: 14px;
  }

  &-button {
    padding: 0 20px;
  }
}
</style>